__turbopack_context__.v({
  "blur": "hero-module__YGUIUq__blur",
  "blurLayer": "hero-module__YGUIUq__blurLayer",
  "content": "hero-module__YGUIUq__content",
  "fallback": "hero-module__YGUIUq__fallback",
  "hero": "hero-module__YGUIUq__hero",
  "media": "hero-module__YGUIUq__media",
  "picture": "hero-module__YGUIUq__picture",
  "pill": "hero-module__YGUIUq__pill",
  "stage": "hero-module__YGUIUq__stage",
  "video": "hero-module__YGUIUq__video",
});
